import { useBigDataLog } from './useBigDataLog';

const useGlobalEvent = true;
const DATA_ATTR_BDL = 'data-big-data-log';

function install(app) {
    const bigDataLog = useBigDataLog();

    const attachEvent = {
        mounted: function (el, binding) {
            el.__onClick = () => {
                const bigDataLog = useBigDataLog();
                const names = bigDataLog.resourceIdToNames(binding.value);
                bigDataLog.sendDetailMessage({
                    model_name1: names[0],
                    model_name2: names[1],
                    model_name3: names[2],
                    model_name4: names[3]
                });

                // console.log('bigdata', binding.value, names);
            };
            el.addEventListener('click', el.__onClick);
        },
        unmounted: function (el, binding) {
            el.removeEventListener('click', el.__onClick);
        }
    };

    const attachAttr = {
        mounted: function (el, binding) {
            el.setAttribute(DATA_ATTR_BDL, binding.value);
        }
    };

    if (useGlobalEvent) {
        // 注意：第三个参数为 true, 使用 “事件捕获”, 避免 click 事件被 stopPropagation 掉
        window.addEventListener('click', sendBigDataLogOnClick(bigDataLog), true);
    }

    app.directive('bigdatalog', useGlobalEvent ? attachAttr : attachEvent);
}

export default {
    install
};

function sendBigDataLogOnClick(bigDataLog) {
    return ev => {
        let target = ev.target;
        while (target && (target.tagName || '').toLowerCase() !== 'body') {
            const resourceId = target.getAttribute(DATA_ATTR_BDL);
            if (resourceId) {
                const names = bigDataLog.resourceIdToNames(resourceId);
                bigDataLog.sendDetailMessage({
                    model_name1: names[0], // 菜单
                    model_name2: names.length === 2 ? names[0] : names[1], // 页面，如果只有一级菜单(即菜单是页面)，则model_name2用names[0]
                    model_name3: '', // 标签页
                    model_name4: names.length === 2 ? names[1] : names[2] // 按钮，如果只有一级菜单(即菜单是页面)，则model_name4用names[1]
                });
                break;
            }

            target = target.parentNode;
        }
    };
}
